<template>
  <section id="header-section">
    <div class="customer-service-header" :class="hidden">
      <div class="row">
        <div class="col-12 p-xl-0 p-sm-2 small">
          Customer Service &nbsp;
          <i class="fas fa-phone"></i>
          <a href="tel:+6621131138">02-113-1138</a>,
          <a href="tel:+66927572999">092-757-2999</a>

          <!-- <div class="line-contact">
            <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img src="/static/img/line-logo.png" style="max-height: 24px;" class="img-fluid" alt="">
              <span>@beneat</span>
            </a>

          </div> -->

        </div>

      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm bg-white"
         :class="hidden">
      <div class="container p-0">
        <router-link to="/" tag="a" class="navbar-brand">
          <img src="/static/img/main-logo.svg"
               class="logo"
               :style="$mq.phone ? 'padding: 0 1rem' : ''"
               height="38"
               alt="BeNeat.co - ผู้ช่วยค้นหาแม่บ้านคุณภาพใกล้บ้านคุณ จองแม่บ้านออนไลน์ได้สะดวก รวดเร็ว พร้อมรับประกันคุณภาพ | Easy way to find your local cleaning expert">
        </router-link>

        <div class="d-flex"  >
          <div class="dropdown mr-3" v-if="$mq.phone">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ $i18n.locale.toUpperCase() }}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item"
                 href="#"
                 @click.prevent="$parent.setLocaleLanguage('en')">EN</a>
              <a class="dropdown-item"
                 href="#"
                 @click.prevent="$parent.setLocaleLanguage('th')">TH</a>
            </div>
          </div>

          <button class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  :class="hiddenWhenBooking">
            <span class="navbar-toggler-icon"></span>
          </button>
        </div>


        <div class="collapse navbar-collapse" id="navbarSupportedContent" >
          <ul class="navbar-nav ml-auto" :class="hiddenWhenBooking">
            <li class="nav-item">
              <router-link class="nav-link" to="/promotions">{{ $t('message.menu.promotions') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/pricing">{{ $t('message.menu.pricing') }}</router-link>
            </li>
            <li class="nav-item" v-if="user">
              <router-link class="nav-link" to="/my-reservations">{{ $t('message.menu.my_reservations') }}</router-link>
            </li>

            <li class="nav-item dropdown dropdown-md dropdown-box" v-if="user">
              <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                {{ $t('message.menu.messages') }}
                <template v-if="newInbox">
                  <svg class="notification-alert">
                    <circle cx="3" cy="3" r="3"/>
                  </svg>
                </template>
              </a>
              <div class="dropdown-menu row custom-dropdown"
                   :class="[ !$mq.desktop ? 'user-menu-md' : 'user-menu-lg' ]">
                <div class="inbox-group">
                  <div class="col-12">
                    <div class="row text-order-title my-3">
                      <div class="col-6 p-0">
                        <strong>
                          {{ $t('message.menu.messages') }} <span v-if="inboxMessages.length > 0">({{ inboxMessages.length }})</span>
                        </strong>
                      </div>

                      <div class="col-6 p-0 text-right">
                        <router-link class="text-primary-link" to="/inbox">{{ $t('message.see_all') }} <i
                          class="fal fa-angle-right"></i></router-link>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <template v-if="isFetchingMessage">
                      <div class="text-center w-100 mb-4">
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <router-link
                        class="no-style"
                        :to="convertUrl(chat)" v-for="(chat, index) in inboxMessages"
                        :key="index" @click.native="hasReadMessage(chat.last_message)">
                        <div class="d-flex justify-content-start align-items-center">
                          <div class="mr-3">
                            <img :src="showPicture(chat.professional)"
                                 width="50"
                                 class="rounded-circle img-fluid"
                                 v-if="chat.professional">
                          </div>

                          <div class="text-small">
                            <label class="mb-0">{{ chat.professional.full_name | firstName }}</label>
                            <span class="m-0">
                              <template v-if="chat.last_message.message_type_id !== 1">
                                 <span v-if="chat.last_message.sender_type === 'user'">
                                  {{ (chat.last_message.message_type_id === 2) ? $t('message.inbox.you_sent_photo') : $t('message.inbox.you_sent_location') }}
                                </span>
                                <span v-else>
                                  {{ (chat.last_message.message_type_id === 2) ? $t('message.inbox.sent_photo') : $t('message.inbox.sent_location') }}
                                </span>
                              </template>
                              <template v-else>
                                {{ chat.last_message.message }}
                              </template>
                            </span>
                            <div class="m-0 text-secondary">
                              {{ convertTimespan(chat.last_message.create_date) }}
                            </div>
                          </div>
                        </div>
                        <hr v-if="_.last(inboxMessages).id !== chat.id">
                      </router-link>
                    </template>
                    <p class="text-muted text-center"
                       v-if="!isFetchingMessage && inboxMessages.length <= 0">
                      {{ $t('message.menu.dropdown_message.empty_message') }}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="notification-group">
                  <div class="col-12">
                    <div class="row text-order-title my-3">
                      <div class="col-6 p-0">
                        <strong>
                          {{ $t('message.menu.notifications') }} <span v-if="notifications.length > 0">({{ notifications.length }})</span>
                        </strong>
                      </div>
                      <div class="col-6 p-0 text-right">
                        <router-link class="text-primary-link" to="/notifications">{{ $t('message.see_all') }} <i
                          class="fal fa-angle-right"></i></router-link>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="text-center w-100 mb-4" v-if="isFetchingNoti">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <router-link
                      class="no-style"
                      :to="{name: 'My Reservation', params: {id: notification.notification_data.order_id}  }"
                      @click.native="hasReadActivity(notification.id)"
                      v-for="(notification, index) in notifications" :key="index">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="mr-3">
                          <img :src="notification.notification_data.professional_picture"
                               width="50"
                               class="rounded-circle img-fluid">
                        </div>
                        <div class="text-small">
                          <div>
                            <label class="mb-0">{{ notification.notification_data.professional_name | firstName }}</label>
                            {{ notification.activity_type_name }}
                            <span v-if="notification.notification_data.order_code">
                              #{{ notification.notification_data.order_code }}
                            </span>
                            <span v-else-if="notification.notification_data.order_id">
                              #{{ notification.notification_data.order_id }}
                            </span>
                          </div>
                          <div class="text-secondary">
                            {{ convertTimespan(notification.time) }}
                          </div>
                        </div>
                      </div>
                      <hr v-if="_.last(notifications).id !== notification.id">
                    </router-link>
                    <p class="text-muted text-center"
                       v-if="!isFetchingNoti && notifications.length <= 0">
                      {{ $t('message.menu.dropdown_message.empty_notification') }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <!-- Blog section -->
             <li class="nav-item navbar-blog">
              <router-link class="nav-link" to="/blog">Blog</router-link>
             </li>
            <!-- End blog section -->
            <!-- Login section -->
            <li class="nav-item" v-if="!user">
              <a class="nav-link" href="" @click.prevent="$parent.openModal('login')">
                {{ $t('message.menu.login_signup') }}
              </a>
            </li>
            <li class="nav-item dropdown" v-if="user">
              <a href="#" class="dropdown-toggle nav-link" id="navbarUser" data-toggle="dropdown" aria-expanded="false">
                <img v-lazy="user.picture" class="rounded-circle" width="30">
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarUser">
                <div :class="[ !$mq.desktop ? 'text-small user-menu-md overflow-auto' : 'user-menu-lg' ]">
                  <router-link class="dropdown-item" to="/user/edit">
                    <i class="fal fa-user"></i> {{ $t('message.menu.edit_profile') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item" to="/user/listings">
                    <i class="fal fa-home"></i> {{ $t('message.menu.my_listings') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/company-address">
                    <i class="fal fa-building"></i> {{ $t('message.menu.company_address') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/payment">
                    <i class="fal fa-credit-card"></i> {{ $t('message.menu.payment_method') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/notifications">
                    <i class="fal fa-bell"></i> {{ $t('message.menu.notification_settings') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item" to="/rewards">
                    <i class="fal fa-trophy-alt"></i> {{ $t('message.menu.beneat_rewards') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/invite">
                    <i class="fal fa-gift"></i> {{ $t('message.menu.invite_friends') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/credits">
                    <i class="fal fa-wallet"></i> {{ $t('message.menu.my_credits_number', {
                    credits: user.totalCredits
                  }) }}
                  </router-link>
                  <!--                  <router-link class="dropdown-item" to="/user/my-reviews">-->
                  <!--                    <i class="fal fa-star"></i> {{ $t('message.menu.my_reviews') }}-->
                  <!--                  </router-link>-->
                  <router-link class="dropdown-item" to="/user/my-vouchers">
                    <i class="fal fa-ticket"></i> {{ $t('message.promo_code.my_vouchers') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/personal-data-management">
                    <i class="fal fa-user-shield"></i> {{ $t('message.menu.personal_data_management') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item"
                    href="https://line.me/R/ti/p/@BeNeat"
                    target="_blank">
                    <i class="fal fa-comments"></i> {{ $t('message.menu.contact_customer_service') }}
                  </a>
                  <a class="dropdown-item"
                    href="#"
                    @click.prevent="$parent.openLogoutDialog()">
                    <i class="fal fa-sign-out"></i> {{ $t('message.menu.logout') }}
                  </a>
                </div>
              </div>
            </li>
            <!-- End login section -->
            <li class="nav-item dropdown" v-if="$mq.desktop">
              <a class="nav-link dropdown-toggle" href="#" id="navbarLanguage" role="button" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">
                <img :src="flagImage">
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarLanguage">
                <a class="dropdown-item"
                   href="#"
                   @click.prevent="$parent.setLocaleLanguage('en')">
                  English
                </a>
                <a class="dropdown-item"
                   href="#"
                   @click.prevent="$parent.setLocaleLanguage('th')">
                  ภาษาไทย
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="progress" :class="progressDisplay">
      <div class="progress-bar"
           :style="'width:' + (state.currentStep / 3) * 100 + '%'">
      </div>
    </div>
  </section>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'

export default {
  data () {
    return {
      noHeaderPaths: ['/promotion', '/promotion-review',
        '/professional-income/:id', '/professional-bonus/:id', '/professional-debt/:id',
        '/cleaner/:id/card', '/subscription-detail', '/recent-reviews',
        '/twitter-campaign', '/facebook-post', '/user/:id/calendar', '/chat-booking', '/article/category', '/article/category/:name',
        '/line-provider/login', '/line-professional/login', '/line-professional/callback', '/invite-friends', '/finnix',
        '/professional/:id/examination', '/professional-questionnaire/:id/test', '/pre-qr-payments', '/job-posts', '/job-posts/:id', '/services/:id',
        '/partners/:id/report', '/professional-login', '/professional-dashboard', '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/inconvenience-maintenance',
        '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/cleaner/:id/contracts/1', '/cleaner/:id/contracts/2',
        '/big-cleaning', '/agency-professional-register', '/user/shipping-address', '/survey-ironing', '/survey-bathroom-cleaning', '/cleaner/:id/consents/1', '/cleaner/consents/1', '/cleaner/:id/consents/2', '/survey/1',
        '/feedback/operation', '/recruitment', '/mikuagency', '/million-booking-celebrate', '/lineman-promotion', '/admin/:id/test/:testId'
      ],
      queryData: {
        page: 0,
        limit: 3,
        dropdown_menu: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      newInbox: 'notification/getNewInbox',
      state: 'booking/getState',
      user: 'auth/getUser'
    }),

    ...mapState({
      notifications: state => state.user.notificationDropdown,
      inboxMessages: state => state.message.inboxMessages,
      isFetchingNoti: state => state.user.isFetchingNoti,
      isFetchingMessage: state => state.message.isFetchingDropdown
    }),

    hidden () {
      return {
        'd-none': (this.noHeaderPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    },
    flagImage () {
      return (this.$i18n.locale === 'en') ? '/static/img/flag-en.jpg' : '/static/img/flag-th.jpg'
    },
    hiddenWhenBooking () {
      return {
        'd-none': this.$route.matched[0].path === '/booking'
      }
    },
    progressDisplay () {
      return {
        'd-none': this.$route.matched[0].path !== '/booking'
      }
    }
  },
  methods: {
    showPicture (professional) {
      if (professional && professional.picture) {
        return professional.full_picture
      } else {
        return '/static/img/unknown.png'
      }
    },
    convertUrl (chat) {
      if (chat) {
        return `/message?cid=${chat.id}&pid=${chat.professional_id}`
      } else if (chat.last_message.sender_type === 'professional') {
        return `/message?cid=0&pid=${chat.last_message.sender_id}`
      }
    },
    hasReadMessage (message) {
      let recipientType = message.sender_type === 'user' ? 'professional' : 'user'
      let recipientId = 0
      if (message.sender_type === 'professional' && message.chat_room) {
        recipientId = message.chat_room.user_id
      } else if (message.sender_type === 'user' && message.chat_room) {
        recipientId = message.chat_room.professional_id
      }
      this.$store.dispatch('message/SET_MESSAGE_READ_DROPDOWN', {
        recipient_type: recipientType,
        message_id: message.id,
        recipient_id: recipientId
      }).then(res => {
        this.$store.dispatch('notification/LOAD_NOTIFICATIONS', this.user.id)
      })
      window.$('li.dropdown-box').dropdown('hide')
    },
    hasReadActivity (idActivity) {
      // eslint-disable-next-line no-unused-vars
      let { data } = axios.put(`users-activities/${idActivity}/update-is-read`)
        .then(res => {
          this.$store.dispatch('notification/LOAD_NOTIFICATIONS', this.user.id)
        })
      window.$('li.dropdown-box').dropdown('hide')
    },
    convertTimespan (time) {
      return moment(time).fromNow()
    },
    fetchDropdown () {
      this.$store.commit('user/SET_NOTIFICATION_DROPDOWN_LIST', [])
      this.$store.dispatch('user/LOAD_NOTIFICATION_ACTIVITY', this.queryData)
      this.$store.dispatch('message/LOAD_MESSAGE_INBOX', this.queryData)
    },
    handleScroll (event) {
      // ระยะตั้งแต่ navbar ลงไป
      if (window.pageYOffset > 70) {
        window.$('section#header-section').addClass('fixed-top')
      } else {
        window.$('section#header-section').removeClass('fixed-top')
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.$('li.dropdown-box').on('show.bs.dropdown', () => {
        this.fetchDropdown()
      })
    })
  },
  created () {
    if (this.user) {
      this.fetchDropdown()
    }
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

@include media-breakpoint-down(xs) {
  .customer-service-header {
    font-size: 85% !important;
  }
}

@include media-breakpoint-down(sm) {
  .customer-service-header {
    font-size: 90%;

    div.line-contact {
      float: right !important;
    }
  }
}

@include media-breakpoint-up(sm) {
  div.line-contact {
    padding-left: 10px;
  }
}

@include media-breakpoint-up(md) {
  .dropdown-md > .dropdown-menu {
    min-width: 450px;
  }

  div.custom-dropdown {
    right: 10px;
    left: -360px;
    top: 65px;
    border-radius: 0;
  }

  div.head-title {
    margin-top: 12px;

    p {
      font-size: 14px;
      font-weight: 500;
    }

  }

  p.content-box {
    font-size: 16px;
    color: #212529;
  }

}


div.line-contact {
  display: inline-block;
}

.dropdown-item {
  padding: 0.75rem;
  word-wrap: break-word !important;
  width: 100% !important;
  white-space: normal;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #bdbdbd;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
.navbar-blog .router-link-active{
  color: #00B4CD;
  font-weight: 600;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

.user-menu-lg {
  min-width: 260px;
  max-width: 100%;
  max-height: 80vh;
  overflow: auto;
}

.user-menu-md {
  width: 100%;
  overflow: auto;
}

@media (max-width: 500px) {
  .user-menu-md {
    max-height: 200px;
    overflow-y: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue